





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Const } from '@/const';
import CommonLayerDrawer from '@/views/designEditor/canvasWindow/layerDrawer/commonLayerDrawer/commonLayerDrawer.vue';

// TODO document2
import { Page } from '@/model/document2/page/page'
import { Design } from '@/model/document2/page/surface/design/design'
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Rectangle } from '@/utilityModels/rectangle'

import * as def from '@/definitions'
import { UnitHelper } from '@/helper/unitHelper';

@Component({
    components: {
        CommonLayerDrawer
    }
})
export default class DesignPreview extends Vue
{
    @Prop() private documentRotate! : number;
    @Prop() private isReverseSurface! : boolean
    @Prop() private page! : Page;
    @Prop() private design! : Design;
    @Prop() private designPosition! : number;
    @Prop() private isRendering! : boolean;
    // 直接印刷ではクライアントで処理するのでサーバー用のフォントになると困る
    @Prop({default : false}) private isRenderingOnClient!: boolean;
    @Prop({default : false}) private isPrint! : boolean;
    @Prop({default : true}) private isFontLoaded! : boolean;
    // サブコントロールとして存在する
    @Prop({default: false}) private subControl! : boolean

    @Prop() private id! : string;

    private useSvg = false;

    private mm2px(mm : number)
    {
        return this.isRendering ? UnitHelper.convert(mm, "mm", "px", 72) : UnitHelper.convert(mm, "mm", "px");
    }

    // サムネイル
    // private get designThumbnail()
    // {
    //     var flowMode = this.$store.getters.applicationState.flowMode;
    //     this.useSvg = false;
    //     if(flowMode == 1 || flowMode == 2 || flowMode == 3)
    //     {
    //         // 差し込みの場合、サムネイルを使用しない
    //         return "";
    //     }
    //     if(this.isRendering)
    //     {
    //         // レンダリングの場合は、サムネイルを使用しない
    //         return "";
    //     }
    //     if(this.subControl && this.isCurrentDesign())
    //     {
    //         // サブコントロールでデザイン編集中の場合は、サムネイルを使用しない
    //         return "";
    //     }
    //     // SVGを使うとレンダリングフォントが再現されないので使いません。
    //     // if(this.design.thumbnailImageBase64 == "")
    //     // {
    //     //     // サムネイルが空の場合はsvgを使う
    //     //     this.useSvg = true;
    //     //     return this.design.thumbnailSvg;
    //     // }

    //     // サムネイル画像は生成のとき、角度を0に戻している
    //     return this.design.thumbnailImageBase64;
    // }

    // 編集中のデザインかどうか？
    private isCurrentDesign()
    {
        var surface = this.page.getSurface(this.isReverseSurface);
        var design = surface.getDesign(this.page.currentDesignPosition);
        return this.design == design;
    }

    private get thumbnailRect()
    {
        // デザインの周りに最大塗り足し幅余白
        var designRect = this.getDesignRect();
        var x = this.mm2px(designRect.x - Const.BLEED_SIZE_MAX);
        var y = this.mm2px(designRect.y - Const.BLEED_SIZE_MAX);
        var w = this.mm2px(designRect.width + Const.BLEED_SIZE_MAX * 2);
        var h = this.mm2px(designRect.height + Const.BLEED_SIZE_MAX * 2);

        if(this.documentRotate == 90 || this.documentRotate == 270)
        {
            // 縦・横逆転
            var temp = w;
            w = h;
            h = temp;
        }

        return new Rectangle(x, y, w, h);
    }

    private getBleedRect()
    {
        return this.page.getSurface(this.isReverseSurface).getBleedRect(this.designPosition, this.getBleedSize());
    }

    private getDesignRect()
    {
        return this.page.getSurface(this.isReverseSurface).getDesignRect(this.designPosition);
    }

    private getFrameRadius()
    {
        return this.page.getSurface(this.isReverseSurface).getFrameRadius(this.designPosition);
    }

    private getFrameInnerCircleRadius()
    {
        return this.page.getSurface(this.isReverseSurface).getFrameInnerCircleRadius(this.designPosition);
    }

    // 塗り足しサイズ
    private getBleedSize()
    {
        return this.$store.getters.userConfig.bleedSize;
    }

    private get allLayers() : Array<Layer>
    {
        return this.design.getAllLayers(false);
    }

    private get layerOffsetX()
    {
        var designRect = this.getDesignRect();
        return this.mm2px(designRect.x);
    }

    private get layerOffsetY()
    {
        var designRect = this.getDesignRect();
        return this.mm2px(designRect.y);
    }

    private get transform()
    {
        var transform = "";

        // オフセット
        transform += "translate(" + (this.layerOffsetX) + " " + (this.layerOffsetY) + "),";

        var designW = this.mm2px(this.design.width);
        var designH = this.mm2px(this.design.height);

        if(this.design.rotate == 90)
        {
            transform += "translate(" + 0 + " " + designW + "),";
        }
        else if(this.design.rotate == 180)
        {
            transform += "translate(" + designW + " " + designH + "),";
        }
        else if(this.design.rotate == 270)
        {
            transform += "translate(" + designH + " " + 0 + "),";
        }

        // 回転を適用する
        transform += "rotate(" + (-this.design.rotate) + "),";

        // 反転の対応
        var isFlip = this.$store.getters.userConfig.isPrintFlip;
        if(isFlip)
        {
            if(this.design.rotate == 90)
            {
                transform += "translate(" + 0 + " " + designH + "),";
                transform += "scale(1 -1),";
            }
            else if(this.design.rotate == 180)
            {
                transform += "translate(" + designW + " " + 0 + "),";
                transform += "scale(-1 1),";
            }
            else if(this.design.rotate == 270)
            {
                transform += "translate(" + 0 + " " + designH + "),";
                transform += "scale(1 -1),";
            }
            else
            {
                transform += "translate(" + designW + " " + 0 + "),";
                transform += "scale(-1 1),";
            }
        }

        // オフセット
        transform += "translate(" + (-this.layerOffsetX) + " " + (-this.layerOffsetY) + ")";


        return transform;
    }

    // private get thumbnailTransform()
    // {
    //     var transform = "";

    //     var designW = this.mm2px(this.getDesignRect().width);
    //     var designH = this.mm2px(this.getDesignRect().height);

    //     // オフセット
    //     transform += "translate(" + (this.layerOffsetX) + " " + (this.layerOffsetY) + "),";

    //     // 反転の対応
    //     // レイアウト画面では反転をしない。
    //     var isFlip = this.$store.getters.userConfig.isPrintFlip;
    //     if(isFlip)
    //     {
    //         transform += "translate(" + designW + " " + 0 + "),";
    //         transform += "scale(-1 1),";
    //     }

    //     if(this.documentRotate == 90)
    //     {
    //         transform += "translate(" + designW + " " + 0 + "),";
    //     }
    //     else if(this.documentRotate == 180)
    //     {
    //         transform += "translate(" + designW + " " + designH + "),";
    //     }
    //     else if(this.documentRotate == 270)
    //     {
    //         transform += "translate(" + 0 + " " + designH + "),";
    //     }

    //     // 回転を適用する
    //     transform += "rotate(" + (this.documentRotate) + "),";

    //     // オフセット
    //     transform += "translate(" + (-this.layerOffsetX) + " " + (-this.layerOffsetY) + ")";

    //     if(this.useSvg)
    //     {
    //         // 回転を戻す
    //         transform += ",";
    //         transform += "translate(" + (this.thumbnailRect.x + this.thumbnailRect.width / 2) + " " + (this.thumbnailRect.y + this.thumbnailRect.height / 2) + ")";
    //         transform += "rotate(" + (-this.design.thumbnailSvgRotate) + "),";
    //         if(this.design.thumbnailSvgRotate % 180 == 90)
    //         {
    //             var fixScale = Math.max(this.thumbnailRect.width / this.thumbnailRect.height, this.thumbnailRect.height / this.thumbnailRect.width);
    //             transform += "scale(" + fixScale + " " + fixScale + "),"
    //         }
    //         transform += "translate(" + -(this.thumbnailRect.x + this.thumbnailRect.width / 2) + " " + -(this.thumbnailRect.y + this.thumbnailRect.height / 2) + ")";
    //     }

    //     return transform;
    // }

    private get scale()
    {
        return this.mm2px(1);
    }

    // 描画範囲指定
    private get designMaskPathId()
    {
        return "designMaskPath_" + this.id;
    }
    private get designMaskPathUrl()
    {
        return "url(#" + this.designMaskPathId + ")";
    }

    // 印刷領域
    private get printRect()
    {
        // 塗り足し領域を取得する
        var bleedRect = this.getBleedRect();
        // 塗り足し領域をスケーリングする
        var x = this.mm2px(bleedRect.x);
        var y = this.mm2px(bleedRect.y);
        var width = this.mm2px(bleedRect.width);
        var height = this.mm2px(bleedRect.height);

        return new Rectangle(x, y, width, height);
    }

    private get printRadius() : number
    {
        var radius = this.getFrameRadius();
        if(this.getDesignRect().width <= radius * 2)
        {
            // 円と判定
            radius = this.getBleedRect().width / 2;
        }
        return this.mm2px(radius);
    }

    private get isInnerMaskVisible()
    {
        return this.getFrameInnerCircleRadius() > 0;
    }

    private get innerMaskCx()
    {
        var designRect = this.getDesignRect();
        var cx = designRect.x + designRect.width / 2;
        return this.mm2px(cx);
    }

    private get innerMaskCy()
    {
        var designRect = this.getDesignRect();
        var cy = designRect.y + designRect.height / 2;
        return this.mm2px(cy);
    }

    private get innerMaskR()
    {
        var r = this.getFrameInnerCircleRadius();
        // 塗り足し幅の分半径を縮める
        r -= this.getBleedSize();
        return this.mm2px(r);
    }
}

